import enJson from '../localization/en.json';
import jaJson from '../localization/ja.json';

declare var abp: any;

class AbpLocalizationConfigService {
  public async getLocalization() {
    let language;
    if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
      language = "en";
    }
    else {
      language = abp.utils.getCookieValue('Abp.Localization.CultureName');
    }
    language = "en";
    let objReturn;
    switch(language) {
      case "en":
        objReturn = enJson;
        break;
      default:
        objReturn = jaJson;
        break;
    }

    return objReturn;
  }

  public async getCurrentLanguage() {
    let language: string;
    if (!abp.utils.getCookieValue('Abp.Localization.CultureName')) {
      language = "en";
    }
    else {
      language = abp.utils.getCookieValue('Abp.Localization.CultureName');
    }
    language = "en";
    var wanted = abp.localization.languages.filter(function(item: any){
      return (item.name === language);
    });
    
    return wanted.length > 0 ? wanted[0] : null;
  }
}

export default new AbpLocalizationConfigService();
